export default "__VITE_ASSET__5d0f3999__"